export const loadingStore = {
  namespaced: true,
  state: {
    isGlobalLoading: false,
    progress: null,
  },
  mutations: {
    SET_GLOBAL_LOADING(state, payload) {
      state.isGlobalLoading = payload
    },
    SET_PROGRESS(state, payload) {
      state.progress = payload
    },
  },
  actions: {
    show({ commit }, payload = {}) {
      commit('SET_GLOBAL_LOADING', true)
      commit('SET_PROGRESS', payload.progress != null ? payload.progress : null)
    },
    hide({ commit }) {
      commit('SET_GLOBAL_LOADING', false)
      commit('SET_PROGRESS', null)
    },
    setProgress({ commit }, progress) {
      commit('SET_PROGRESS', progress)
    },
  }
}
